<template>
  <div>
    <div class="b-full-table__row b-full-table__row-inner">
      <div class="b-full-table__cell b-full-table__cell_type_flex b-table__cell_width_md">
        <div class="b-payment-row__info">
          <div class="b-payment-row__name">
            {{(manualChartPayment.paymentName)}}
          </div>
          <div class="b-payment-row__info-about">
            <span class="b-payment-row__price-for-unit">{{manualChartPayment.currency}}</span>
          </div>
        </div>
      </div>
      <div class="b-full-table__cell b-table__cell_width_md">{{manualChartPayment.discountRate}}%</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    manualChartPayment: {
      type: Object,
    },
  },
};
</script>
